import React, { Suspense, lazy } from 'react'
import styled from 'styled-components'
import { Route, Routes } from 'react-router'
import Loader from './shared/Loader/Loader'
import Header from './components/Header/Header'
import ScrollToTop from './components/ScrollToTop/ScrollToTop'
import AppRouteNames from './constants/route'
import OpenID from './components/OpenID/OpenID'
import GlobalAlerts from './components/GlobalAlerts/GlobalAlerts'
import WebSocketProvider from './components/WebSocketProvider/WebSocketProvider'
import { TopicCompletionConfettiProvider } from './shared/TopicCompletionConfetti/TopicCompletionConfettiProvider'

const Container = styled('div')({
	width: '100%',
	height: '100%',
	allignItems: 'flex-start',
})

const Content = styled('div')({
	paddingTop: '80px',
	flex: '1 0 auto',

	'& .center-container': {
		display: 'flex',
		flexDirection: 'column',
		height: '100%',
	},
})

const Courses = lazy(() => import('./pages/Courses/Courses'))
const Course = lazy(() => import('./pages/Course/Course'))
const Topic = lazy(() => import('./pages/Topic/Topic'))

const App = () => (
	<OpenID>
		<WebSocketProvider>
			<TopicCompletionConfettiProvider>
				<Container className='App'>
					<ScrollToTop />
					<Header />
					<GlobalAlerts />
					<Content className='content'>
						<Suspense fallback={<Loader />}>
							<Routes>
								<Route path={AppRouteNames.home} element={<Courses />} />
								<Route path={`${AppRouteNames.course}`} element={<Course />} />
								<Route path={`${AppRouteNames.topic}`} element={<Topic />} />
							</Routes>
						</Suspense>
					</Content>
				</Container>
			</TopicCompletionConfettiProvider>
		</WebSocketProvider>
	</OpenID>
)

export default App
